import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContactDetailsComponent} from './contact-details.component';
import {ChappsCommonAngularLibraryModule} from "@npm.chapps.com/chapps.common.angular.library";
import {TranslateModule} from "@ngx-translate/core";
import {CommonsModule} from "../../../../common/common.module";
import {MdProgressSpinnerModule} from "ng-uikit-pro-standard";
import {MatTooltipModule} from '@angular/material/tooltip';


@NgModule({
  declarations: [
    ContactDetailsComponent
  ],
  exports: [
    ContactDetailsComponent
  ],
  imports: [
    CommonModule,
    ChappsCommonAngularLibraryModule,
    TranslateModule,
    CommonsModule,
    MdProgressSpinnerModule,
    MatTooltipModule
  ]
})
export class ContactDetailsModule {
}
